import React from 'react';
import { Input } from 'antd';

import { ReactComponent as GreenEye } from 'src/assets/overall/GreenEye.svg';
import { ReactComponent as GrayEye } from 'src/assets/overall/GrayEye.svg';

import './customInput.scss';
import classNames from 'classnames';

const { Password, TextArea } = Input;

export const CustomInput = ({ label, type = 'text', errorMessage = '', ...rest }) => {
  const typeToComponent = {
    password: Password,
    text: Input,
    number: Input,
    email: Input,
    'text-area': TextArea,
  };

  const Component = typeToComponent?.[type];

  const passwordData = {
    iconRender: (visible) => (visible ? <GreenEye /> : <GrayEye />),
  };

  const passwordProps = type === 'password' ? passwordData : {};

  const labelStyles = classNames('custom-input__label', {
    'custom-input__label--error': errorMessage,
  });

  const inputStyles = classNames('custom-input', {
    'custom-input--error': errorMessage,
  });

  return (
    <div className="custom-input__wrapper">
      {label ? (
        <label htmlFor={label} className={labelStyles}>
          {label}
        </label>
      ) : null}
      <Component
        className={inputStyles}
        id={label ? label : ''}
        type={type}
        {...rest}
        {...passwordProps}
      />
      {errorMessage ? <div className="custom-input__error">{errorMessage}</div> : null}
    </div>
  );
};
